import { commonOverrides } from './base.js'

export const createLightTheme = (given) => {
  const vars = { ...given }
  if (!vars.PRIMARY_COLOR) vars.PRIMARY_COLOR = '#2563eb'
  if (!vars.INFO_COLOR) vars.INFO_COLOR = '#0ea5e9'
  if (!vars.SUCCESS_COLOR) vars.SUCCESS_COLOR = '#10b981'
  if (!vars.ERROR_COLOR) vars.ERROR_COLOR = '#ef4444'
  if (!vars.WARNING_COLOR) vars.WARNING_COLOR = '#f59e0b'
  if (!vars.TEXT_COLOR) vars.TEXT_COLOR = '#111827'
  if (!vars.BASE_COLOR) vars.BASE_COLOR = '#f8fafc'
  if (!vars.BASE_INVERT_COLOR) vars.BASE_INVERT_COLOR = '#111827'

  return {
    common: commonOverrides(vars),
  }
}
